/*
 * @Author: yi
 * @Date: 2023-11-13 14:31:19
 * @LastEditors: yi
 * @LastEditTime: 2023-11-14 11:36:12
 * @Description: file content
 */
import './App.css';
import { useRoutes} from 'react-router-dom';
import Header from './components/header';
import routes from './router/router';


function App() {

  const router = useRoutes(routes)
  
  return (
    <div className="App">
      <Header />
        {router}
    </div>
  );
}

export default App;
